import { Spin } from 'antd';

export default function Spinner() {
  return(
    <Spin style={{ 'position': 'relative', 'display': 'block', 'width': '100%', 'height': '100%' }} />
  )
}